import { ApiModelPortfolio } from '@/api'
import { ModalHeader, SimpleModal } from '@/components/core-v2'
import { PORTFOLIO_TYPE } from '@/constants'

import { ProposedChangesApproval } from './proposed-changes-approval'

interface ProposedChangesModalProps {
  canProceedApproval: boolean
  onApprovePortfolio: () => void
  onChangeApprovalStatus: (status: 'Approved' | 'Rejected' | '') => void
  onChangeApprovalUserName: (userName: string) => void
  onClose: () => void
  portfolio: ApiModelPortfolio
}

export const ApprovalModal = ({
  canProceedApproval,
  onApprovePortfolio,
  onChangeApprovalStatus,
  onChangeApprovalUserName,
  onClose,
  portfolio
}: ProposedChangesModalProps) => (
  <SimpleModal>
    <ModalHeader onClickClose={onClose}>
      Approve or reject this {PORTFOLIO_TYPE[portfolio.type].value} portfolio
    </ModalHeader>
    <ProposedChangesApproval
      canProceedApproval={canProceedApproval}
      portfolio={portfolio}
      onApprovePortfolio={onApprovePortfolio}
      onCancel={onClose}
      onChangeApprovalStatus={onChangeApprovalStatus}
      onChangeApprovalUserName={onChangeApprovalUserName}
    />
  </SimpleModal>
)
